import { Trans } from "@common/i18n/trans";
import { Link } from "@app/dashboard/links/link";
import { useSettings } from "@common/core/settings/use-settings";
import { Navbar } from "@common/ui/navigation/navbar/navbar";
import { ShareLinkButton } from "@app/dashboard/links/sharing/share-link-button";
import { Footer } from "@common/ui/footer/footer";
import { RedirectCountdownButton } from "@app/short-links/renderers/redirect-countdown-button";
import { Button } from "@common/ui/buttons/button";
import { AdHost } from "@common/admin/ads/ad-host";
import { Link as RouterLink } from "react-router-dom";

interface LinkPageRendererProps {
  link: Link;
}
export function LinkSplashRenderer({ link }: LinkPageRendererProps) {
  const { base_url } = useSettings();
  return (
    <div className="flex flex-col w-full h-screen bg-alt">
      <div className="container flex-auto flex flex-col items-center justify-center mx-auto px-24">
        <AdHost slot="splash_top" className="mt-20 mb-60 flex-shrink-0" />
        <div className="md:flex gap-24 p-20 flex-shrink-0">
          <div className="ct-custom-splash">
            <div>
              <RedirectCountdownButton
                variant="flat"
                color="primary"
                link={link}
              />
            </div>
            <div className="text-sm text-muted mt-24">
              <Trans message="Đang chuyển đến nội dung đích..." />
            </div>
          </div>
        </div>
        <AdHost slot="splash_bottom" className="mt-60 mb-20 flex-shrink-0" />
      </div>
    </div>
  );
}
